import React from "react";

import "../src/App.css";

export const LoadingSpinner = props => {
  return (
    <tbody>
      <tr>
        <td colSpan='3'>
          <div className="loader__container">
          <div className="loader__icon"></div>
            <div className="loader">
            
            </div>
          </div>
          
        </td>
      </tr>
    </tbody>
  );
};
